import { Grid, Popover } from "@mui/material";
import ShowSubMenuInfo from "./ShowSubMenuInfo/ShowSubMenuInfo";

export default function InfoSubMenu({open = false, anchorEl={}, info = null, dataSelected}) {
    return (
      <>
          { info !== null && 
            <div>
              <Popover 
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'center',
                  horizontal: 'right',
                }}
              >
                <Grid container>
                  <div style={{padding:"0 0px 0px 0px", width:'23rem'}}>
                    <ShowSubMenuInfo info={info} dataSelected={dataSelected}/>
                  </div> 
                </Grid>
            </Popover> 
            </div>
          }
      </>
    );
}
